import { useEffect } from "react";

/**
 * Custom hook that dynamically updates the page favicon based on the user's preferred color scheme (dark or light mode).
 */
export function useFaviconByTheme(): void {
  useEffect(() => {
    function setFavicon(href: string): void {
      const link: HTMLLinkElement | null =
        document.querySelector("link[rel~='icon']");

      if (link) {
        link.href = href;
      } else {
        const newLink = document.createElement("link");
        newLink.rel = "icon";
        newLink.href = href;
        document.head.appendChild(newLink);
      }
    }

    function updateFavicon(): void {
      const isDarkMode = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches;
      setFavicon(isDarkMode ? "/favicon_dark.ico" : "/favicon_light.ico");
    }

    updateFavicon();

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    mediaQuery.addEventListener("change", updateFavicon);

    return () => {
      mediaQuery.removeEventListener("change", updateFavicon);
    };
  }, []);
}
